import { render, staticRenderFns } from "./UserManageTwo.vue?vue&type=template&id=8823ec18&scoped=true&"
import script from "./UserManageTwo.vue?vue&type=script&lang=js&"
export * from "./UserManageTwo.vue?vue&type=script&lang=js&"
import style0 from "./UserManageTwo.vue?vue&type=style&index=0&id=8823ec18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8823ec18",
  null
  
)

export default component.exports